import { render, staticRenderFns } from "./Tag.component.vue?vue&type=template&id=7343b35b&scoped=true&"
import script from "./Tag.component.vue?vue&type=script&lang=js&"
export * from "./Tag.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7343b35b",
  null
  
)

export default component.exports